<template>
    <button
        :class="{
            'interval-indicator--invalid': isInvalid,
            'interval-indicator--selected': isSelected,
            'interval-indicator--unavailable': isUnavailable,
        }"
        :disabled="isInvalid || isUnavailable"
        type="button"
        class="interval-indicator"
        @click="$emit('click:slot', date, time)"
    />
</template>

<script>
export default {
    name: 'ViewingSlot',
    props: {
        past: {
            type: Boolean,
            required: true
        },
        future: {
            type: Boolean,
            required: true
        },
        date: {
            type: String,
            required: true
        },
        time: {
            type: String,
            required: true
        },
        endDate: {
            type: String,
            required: true
        },
        availabilities: {
            type: Array,
            required: true
        },
        dateSelected: {
            type: String,
            required: true
        },
        timeSelected: {
            type: String,
            required: true
        }
    },
    computed: {
        isInvalid() {
            return this.past || (this.future && !this.$moment(this.date).isBefore(this.endDate, 'minute'));
        },
        isSelected() {
            return this.date === this.dateSelected && this.time === this.timeSelected;
        },
        isUnavailable() {
            return !this.isInvalid && this.future && !this.availabilities.find((slot) => {
                const startTime = this.$moment(`${this.date} ${this.time}`);
                return startTime.format('E') === slot.day.toString()
                    && startTime.format('HH:mm') === slot.start_at;
            });
        }
    }
};
</script>
